/*!
 * doTERRA Web-UI
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 */

export const useJson = () => {

    const parseJson = (source) => {
        try {
            return JSON.parse(source);
        } catch (error) {
            return {error: `Error parsing JSON text: ${error}`};
        }
    };

    const htmlDecode = (input) => {
        let doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.textContent;
    };

    return { parseJson, htmlDecode };
};
